// import { parseVueRouterLink, params } from '@hb/utils-monorepo/url';
import MainStore from '@/store/userStore';
import params from '../param';
import BrowserCallNative from './BrowserCallNative.js';
import unionPay from '../platformUtils/unionPay';

export default class UnionPayCallNative extends BrowserCallNative {
  static callNative(name, data) {
    if (!this[name]) {
      return Promise.reject(new Error(`${name}功能在云闪付App中暂时无法使用`));
    }
    return this[name](data);
  }

  static closeWebView() {
    return unionPay.closeWebView();
  }

  static getTokenAndKey() {
    const locationHref = window.location.href;
    const {
      hashParams: { token, ticket, userGuid } = {},
    } = params.parseVueRouterLink(locationHref) || {};
    // eslint-disable-next-line no-console
    if (token) {
      const userInfo = {
        token,
        ticket: ticket || '',
        userGuid: userGuid || '',
      };
      MainStore.setUserInfo(userInfo);
      return Promise.resolve(userInfo);
    }
    const res = MainStore.getUserStore() || {};
    return Promise.resolve({ ...res });
  }
}
